import { render, staticRenderFns } from "./GenricLoading.vue?vue&type=template&id=68436439&"
import script from "./GenricLoading.vue?vue&type=script&lang=js&"
export * from "./GenricLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports